import React, {ReactElement} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import {cx} from '@emotion/css';
import britishBusinessBankLogo from '@fo/shared-images/BritishBusinessBank-logo.svg';
import {Alignment} from '@fo/shared-types';
import DynamicLink from '@fo/components/DynamicLink/DynamicLink';
import {BBBVariant, Size} from './types';

import styles from './BankingPartnerSection.styles';

export {Size, BBBVariant} from './types';

interface BankingPartnerSectionProps {
  size?: Size;
  alignment?: Alignment;
  bbbVariant?: BBBVariant;
  isBottomPadding?: boolean;
}

function BankingPartnerSection({
  size = Size.MEDIUM,
  alignment = Alignment.CENTER,
  bbbVariant = BBBVariant.NO_TEXT,
  isBottomPadding,
}: BankingPartnerSectionProps): ReactElement {
  const {formatMessage} = useIntl();
  const bbbLogoImage = (
    <img
      src={britishBusinessBankLogo}
      alt={formatMessage({id: 'phoenix.formLayoutSidebar.bankingPartner.bbb.alt'})}
      className={cx(styles.logoImg)}
    />
  );

  return (
    <div className={cx(styles.container(alignment, isBottomPadding))}>
      {bbbVariant === BBBVariant.SHORT_TEXT && (
        <div className={cx(styles.endorsedByText)}>
          <FormattedMessage id="conversion.bankingPartner.bbb.endorsedByText" />
        </div>
      )}
      <DynamicLink className={cx(styles.logoLink)} href={formatMessage({id: 'homepage.bankingPartner.bbb.href'})} blank>
        <div className="">
          <div className={cx(styles.logo(size))}>{bbbLogoImage}</div>
        </div>
      </DynamicLink>
      {bbbVariant === BBBVariant.EXTENDED_TEXT && (
        <div className={cx(styles.text)}>
          <FormattedMessage id="homepage.bankingPartner.britishBusinessBank.text" />
        </div>
      )}
    </div>
  );
}

export default BankingPartnerSection;
